var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Card',{attrs:{"title":_vm.$t('common.undoListTitle')}},[_c('div',{staticClass:"UndoList"},_vm._l((_vm.displayItems),function(item){return _c('div',{key:item.index,class:[
        'UndoListItem',
        item.index === _vm.index && 'UndoListItem__selected',
        item.index > _vm.index && 'UndoListItem__fade'
      ],on:{"click":function($event){return _vm.$emit('change', item.index)}}},[_vm._v("\n      "+_vm._s(item.label)+"\n    ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }